import * as React from "react";
import { VariantProps } from "class-variance-authority";

import { cn } from "@/src/lib/utils";
import { textVariants } from "./typographyVariants";

type TextElement = "p" | "span" | "label" | "div";

interface TextProps
  extends React.HTMLAttributes<HTMLElement>,
    VariantProps<typeof textVariants> {
  as?: TextElement;
}

export function Text({
  as = "p",
  size,
  className,
  children,
  ...props
}: TextProps) {
  const Component = as as "div";
  return (
    <Component
      className={cn(textVariants({ size }), className)}
      {...props}
    >
      {children}
    </Component>
  );
}